import React from 'react';
import { Outlet } from 'react-router-dom';

interface BillsRootPageInterface {}

const BillsRootPage: React.FC<BillsRootPageInterface> = () => <Outlet />;

export default BillsRootPage;
